import { Box, Breadcrumbs, Link, Stack, SxProps } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useBreakpoints from '../../../hooks/useBreakpoint';
import i18n from '../../../localization/i18n';
import { headingFontBold, defaultBorder, vars } from '../../../Theme';

/** Collection of footer URLs in all supported application languages. */
const urls = {
    legal: {
        de: 'https://www.thinkproject.com/de/impressum/',
        en: 'https://www.thinkproject.com/imprint/',
    },
    privacy: {
        de: 'https://www.thinkproject.com/de/datenschutzerklaerung/',
        en: 'https://www.thinkproject.com/data-protection-statement/',
    },
};

/**
 * Helper component for creating footer link elements.
 */
const FooterLink = (props: { text: string; url: string }) => (
    <Link
        href={props.url}
        underline='none'
        target='_blank'
        sx={{
            color: 'inherit',
        }}
    >
        {props.text}
    </Link>
);

/** Footer font styles. */
const fontSx: SxProps = {
    color: vars.font,
    ...headingFontBold,
    fontSize: 12,
};

/**
 * Application Footer (shows legal information, etc.).
 */
export default () => {
    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'footer' });

    /** Determine screen size. */
    const { isDesktop } = useBreakpoints();

    /** Create the Footer Link elements. */
    const links = Object.keys(urls).map((key: string) => {
        /** Use the english URL as a fallback. */
        const url = urls[key][i18n.language] ?? urls[key].en;

        return <FooterLink key={key} url={url} text={t(key)} />;
    });

    return (
        <Stack
            direction='row'
            sx={{
                alignItems: 'center',
                borderTop: defaultBorder,
                px: isDesktop ? 4.5 : 2,
                height: 30,
            }}
        >
            <Box sx={{ ...fontSx, flexGrow: 4 }}>
                &copy; {new Date().getFullYear()} Thinkproject
            </Box>
            <Breadcrumbs separator='|' sx={{ ...fontSx }}>
                {links}
            </Breadcrumbs>
        </Stack>
    );
};
